import auth from '../actions/auth';

const initState = {
  isLogin: localStorage.getItem('isLogin') === 'true',
  token: localStorage.getItem('token') || document.cookie.split('=').pop() || null,
  user: {},
  permissions: []
};

export default function authReducer(state = initState, action) {
  switch (action.type) {
    case auth.LOGIN:
      return {
        ...state,
        isLogin: action.isLogin,
        token: action.token,
      };
    case auth.SET_USER:
      return {
        ...state,
        user: action.user
      };
    case auth.PERMISSION_USER:
      return {
        ...state,
        permissions: action.permissions
      };
    case auth.LOGOUT:
      return {
        ...state,
        isLogin: action.isLogin,
        token: null,
        user: {},
        permissions: []
      };
    default:
      return state;
  }
}
